module.exports = {
  title: 'Dot Sheet Animation with Reanimated and Skia',
  author: 'Enzo Manuel Mangano',
  date: '2024-07-16',
  slug: 'dot-sheet',
  tags: ['reanimated', 'skia'],
};
